var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("CheckoutAddressForm", {
        ref: "billingForm",
        attrs: {
          "form-fields": _vm.billingFields,
          "default-values": _vm.defaultValuesForBilling,
          "form-name": "billing",
          "user-logged-in": _vm.userLoggedIn
        }
      }),
      _vm._v(" "),
      _c("CheckoutAddressForm", {
        ref: "shippingForm",
        attrs: {
          "form-fields": _vm.shippingFields,
          "default-values": _vm.defaultValuesForShipping,
          "form-name": "shipping",
          "user-logged-in": _vm.userLoggedIn
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "form-footer" }, [
        _c(
          "button",
          {
            staticClass: "btn btn--block",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.validateForms()
              }
            }
          },
          [_vm._v("\n      " + _vm._s(_vm.$modeoL10n.continue) + "\n    ")]
        ),
        _vm._v(" "),
        _c("p", { staticClass: "form-disclaimer" }, [
          _vm._v(
            "\n      " + _vm._s(_vm.$modeoL10n.asterisk_explanation) + "\n    "
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc4e15a6", { render: render, staticRenderFns: staticRenderFns })
  }
}